export default "__VITE_ASSET__1VVUsH5m__"